'use client';

import { c as _c } from "react/compiler-runtime";
import { PosthogProvider } from './analytics/posthog-provider';
import { TanstackProvider } from './tanstack/tanstack-provider';
export const SdkProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TanstackProvider><PosthogProvider>{children}</PosthogProvider></TanstackProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};